export const filters = {
  toBrazilianDateTime(date) {
    if (!date) return 'Não Definida'
    const utcDate =
      date instanceof Date
        ? date
        : new Date(date.endsWith('Z') ? date : date + 'Z')
    return new Intl.DateTimeFormat('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(utcDate)
  },
  toUTCDateTime(date) {
    if (!date) return 'Não Definida'
    return new Intl.DateTimeFormat('pt-BR', {
      timeZone: 'UTC',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(new Date(date))
  },
  iso2br(date) {
    if (!date) return 'Não Definida'
    const utcDate = date.endsWith('Z') ? date : date + 'Z'
    return new Intl.DateTimeFormat('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(new Date(utcDate))
  },
}
